import { createFileRoute } from '@tanstack/react-router';

import { config } from '@/constants/config';

export const Route = createFileRoute('/(landing)/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="container mx-auto max-w-3xl px-4 py-12">
      <h1 className="mb-8 text-3xl font-bold">Termos de Uso</h1>

      <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
        <p className="text-muted-foreground">
          Última atualização: {new Date().toLocaleDateString('pt-BR')}
        </p>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">1. Aceitação dos Termos</h2>
          <p>
            Ao acessar ou usar o eumimo, você concorda em cumprir estes Termos
            de Uso. Se você não concordar com qualquer parte destes termos, não
            deverá usar nosso serviço.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">2. Descrição do Serviço</h2>
          <p>
            O eumimo é uma plataforma que permite casais criarem e
            compartilharem listas de desejos de forma privada, facilitando a
            troca de presentes em datas comemorativas.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">3. Cadastro e Conta</h2>
          <ul className="list-inside list-disc space-y-2">
            <li>
              Você deve fornecer informações verdadeiras e atualizadas ao criar
              sua conta.
            </li>
            <li>
              Você é responsável por manter a segurança do acesso à sua conta.
            </li>
            <li>Você deve ter pelo menos 18 anos para usar nossos serviços.</li>
            <li>Cada pessoa pode ter apenas uma conta ativa no eumimo.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">4. Uso Aceitável</h2>
          <p>Ao usar o eumimo, você concorda em não:</p>
          <ul className="list-inside list-disc space-y-2">
            <li>Violar qualquer lei ou regulamento aplicável</li>
            <li>Usar o serviço para fins fraudulentos ou enganosos</li>
            <li>
              Compartilhar conteúdo ofensivo, ilegal ou que viole direitos de
              terceiros
            </li>
            <li>Tentar acessar contas de outros usuários sem autorização</li>
            <li>
              Usar bots, scrapers ou outros meios automatizados para acessar o
              serviço
            </li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">5. Planos e Pagamentos</h2>
          <h3 className="text-lg font-medium">5.1 Plano Gratuito</h3>
          <p>
            O plano gratuito oferece funcionalidades básicas com limites de
            itens e datas comemorativas conforme descrito em nossa página de
            preços.
          </p>

          <h3 className="text-lg font-medium">5.2 Plano Pro</h3>
          <ul className="list-inside list-disc space-y-2">
            <li>
              Assinaturas são renovadas automaticamente conforme o ciclo
              escolhido (mensal ou anual).
            </li>
            <li>
              Os pagamentos são processados por parceiros de pagamento seguros.
            </li>
            <li>
              Você pode cancelar sua assinatura a qualquer momento nas
              configurações da conta.
            </li>
            <li>O cancelamento entra em vigor ao final do período já pago.</li>
          </ul>

          <h3 className="text-lg font-medium">5.3 Reembolso</h3>
          <p>
            Oferecemos reembolso integral em até 7 dias após a primeira compra,
            sem necessidade de justificativa. Após esse período, não haverá
            reembolso por períodos parciais.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">6. Propriedade Intelectual</h2>
          <p>
            O eumimo, incluindo sua marca, design, código e conteúdo original, é
            propriedade da empresa. Você não pode copiar, modificar ou
            distribuir qualquer parte do serviço sem nossa autorização prévia
            por escrito.
          </p>
          <p>
            O conteúdo que você adiciona às suas listas (como nomes de produtos
            e links) permanece de sua propriedade.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">
            7. Limitação de Responsabilidade
          </h2>
          <p>
            O eumimo é fornecido &quot;como está&quot;. Não garantimos que o
            serviço estará sempre disponível ou livre de erros.
          </p>
          <p>Em nenhuma circunstância seremos responsáveis por:</p>
          <ul className="list-inside list-disc space-y-2">
            <li>Danos indiretos, incidentais ou consequenciais</li>
            <li>Perda de dados além do que está sob nosso controle razoável</li>
            <li>
              Ações de terceiros, incluindo os produtos sugeridos nas listas
            </li>
            <li>Interrupções temporárias do serviço para manutenção</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">8. Encerramento de Conta</h2>
          <p>
            Você pode encerrar sua conta a qualquer momento através das
            configurações do aplicativo.
          </p>
          <p>
            Reservamo-nos o direito de suspender ou encerrar contas que violem
            estes Termos de Uso, sem aviso prévio.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">9. Alterações nos Termos</h2>
          <p>
            Podemos modificar estes Termos de Uso a qualquer momento. Alterações
            significativas serão comunicadas por email ou através do aplicativo
            com pelo menos 30 dias de antecedência.
          </p>
          <p>
            O uso continuado do serviço após as alterações constitui aceitação
            dos novos termos.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">10. Legislação Aplicável</h2>
          <p>
            Estes Termos de Uso são regidos pelas leis da República Federativa
            do Brasil. Qualquer disputa será resolvida nos foros da comarca de
            São Paulo, SP.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">11. Contato</h2>
          <p>Para dúvidas sobre estes Termos de Uso, entre em contato:</p>
          <p>
            <strong>Email:</strong> {config.company.email}
            <br />
            <strong>CNPJ:</strong> {config.company.cnpj}
          </p>
        </section>
      </div>
    </div>
  );
}
